import { ForeignKeyField } from "lego-gui-lib";
import { Required, Schema, TextField } from "lego-gui-lib/lib";
import { LabelFieldOption } from "../../../common/common";
import { ContextAwareListDataSource } from "../../../common/ContextAwareListDataSource";
import { t } from "../../../core/i18n/i18n";
import { api, mainStore } from "../../../core/mainStore";
import { Auth } from "../../../core/model/auth";
import { CalendarDayTypeDataSource } from "../dayTypeDatasource/CalendarDayTypeDataSource";
import { CalendarFK } from "../schema";
import { ColorField } from "./colorFieldComponent";

export const CalendarDayTypeSchema = new Schema({
  fields: [
    {
      name: "name",
      title: t("common:name"),
      type: TextField(Required),
      filter: false,
      sort: false
    },
    {
      name: "color",
      title: t("common:color"),
      type: ColorField(),
      filter: false,
      sort: false
    },
    {
      name: "calendarRef",
      title: t("hns:listEntry:parentName"),
      type: CalendarFK,
      readonly: true,
      filter: false,
      sort: false
    }
  ],
  primaryKey: ["id"],
  security: {
    readableRole: Auth.Roles.ANYONE,
    editableRole: Auth.Roles.ANYONE_WITH_WRITE
  }
});

export const CalendarDayTypeSchemaColumns = CalendarDayTypeSchema.extend({
  calendarRef: false
});

mainStore.calendarDayType = new CalendarDayTypeDataSource({
  parent: mainStore.calendar.oneDataSource,
  api: api,
  name: "calendarDayType",
  schema: CalendarDayTypeSchema,
  url: "/dayTypes",
  commons: mainStore.commons
});

mainStore.calendarDayTypes = new CalendarDayTypeDataSource({
  parent: mainStore.calendar.oneDataSource,
  api: api,
  name: "calendarDayTypes",
  schema: CalendarDayTypeSchema,
  url: "/calendarDayTypes",
  commons: mainStore.commons
});

mainStore.calendarDayTypesFk = ContextAwareListDataSource.clone(
  mainStore.calendarDayTypes,
  {
    observableField: "calendarRef",
    observableFieldRef: "calendarRef",
    observableDataSource: "SAN"
  }
);

export const CalendarDayTypesFK = ForeignKeyField(
  {
    dataSource: mainStore.calendarDayTypesFk,
    searchField: "name",
    labelField: (option: LabelFieldOption) => `${option.name}`,
    valueField: "id",
    minWidth: 70
  },
  Required
);
